import { styled } from 'styled-components';
import {
  BodyTextBoldSecondary,
  BoldHeadingSecondary,
} from '@/shared/ui/typography';
import SpinnerMedium from '@/shared/assets/animated-spinner-medium.svg';

export const Header = styled.div`
  background-image:
    linear-gradient(
      180deg,
      rgba(26, 31, 44, 0.8) 0%,
      rgba(37, 44, 62, 0.24) 168.75%
    ),
    url('/images/background/history-detail-header.png');
  background-position: center, center;
  position: absolute;
  background-size: 100%;
  top: 0;
  left: 0;
  padding-top: 54px;
  padding-bottom: 48px;
  width: 100%;
  z-index: 0;

  ${({ $type, $status }) =>
    $type === 'deposit' &&
    $status === 'success' &&
    `
     background-image: linear-gradient(
      180deg,
      rgba(26, 31, 44, 0.8) 0%,
      rgba(37, 44, 62, 0.24) 168.75%
    ),
        url('/images/background/history-detail-header-down.png');

  `}

  ${({ $type, $status }) =>
    $status === 'denied' &&
    `
     background-image: linear-gradient(
      180deg,
      rgba(26, 31, 44, 0.8) 0%,
      rgba(37, 44, 62, 0.24) 168.75%
    ),
        url('/images/background/history-detail-header-error.png');

  `}

   ${({ $type, $status }) =>
    $status === 'error' &&
    `
     background-image: linear-gradient(
      180deg,
      rgba(26, 31, 44, 0.8) 0%,
      rgba(37, 44, 62, 0.24) 168.75%
    ),
        url('/images/background/history-detail-header-error.png');

  `}
`;

export const HeaderIcon = styled.div`
  box-shadow: 0px 0px 0px 3px #161639;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  background-image: url('/images/background/down-circle-medium.svg');
  background-repeat: no-repeat;
  background-size: 35px;
  background-position: center;
  background-color: #414d6b;
  position: absolute;
  top: 110px;
  left: 50%;
  transform: translate(-50%);

  ${({ $type, $status }) =>
    $type === 'deposit' &&
    $status === 'success' &&
    `
    transform:translate(-50%) rotate(180deg);
  `}

  ${({ $status }) =>
    $status === 'error' &&
    `
      background-color: rgba(218, 68, 68, 0.24);
      background-image: url('/images/background/close-remove-medium.svg');


  `}

    ${({ $status }) =>
    $status === 'denied' &&
    `
      background-color: rgba(218, 68, 68, 0.24);
      background-image: url('/images/background/close-remove-medium.svg');


  `}
`;

export const HistoryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-bottom: 1px solid #1b202d;
  padding: 12px 0;

  ${({ $last }) =>
    $last &&
    `
    border-bottom: none;
  `}
`;

export const HistoryContent = styled.div`
  padding-top: 140px;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const HistoryStatus = styled.div`
  color: #edeff5;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
  padding: 0px 4px;
  border-radius: 4px;
  ${({ $status }) =>
    $status === 'pending' &&
    `
  background-color: #55648A;
`}

  ${({ $status }) =>
    $status === 'verification' &&
    `
  background-color: #55648A;
`}

${({ $status }) =>
    $status === 'error' &&
    `
  background-color: #DA4444;
`}

${({ $status }) =>
    $status === 'denied' &&
    `
  background-color: #DA4444;
`}

${({ $status }) =>
    $status === 'success' &&
    `
  background-color: #08AD5E;
`}
`;

export const WalletAddress = styled(BodyTextBoldSecondary)`
  word-break: break-word;
  text-align: left;
`;

export const HeaderTitle = styled(BoldHeadingSecondary)`
  ${({ $status }) =>
    $status === 'pending' &&
    `
  color: #55648A;
`}
  ${({ $status }) =>
    $status === 'verification' &&
    `
  color: #55648A;
`}

${({ $status }) =>
    $status === 'success' &&
    `
  color: #08AD5E;
`}

${({ $status }) =>
    $status === 'denied' &&
    `
    color:#DA4444;
  `}

  ${({ $status }) =>
    $status === 'error' &&
    `
    color:#DA4444;
  `}
`;

export const AnimatedSpinnerWrapper = styled.div`
  box-shadow: 0px 0px 0px 6px #161639;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  background-image: url('/images/background/down-circle-medium.svg');
  background-repeat: no-repeat;
  background-size: 35px;
  background-position: center;
  background-color: #414d6b;
  position: absolute;
  top: 110px;
  left: 50%;
  transform: translate(-50%);
`;
export const AnimatedSpinnerMedium = styled(SpinnerMedium)`
  position: absolute;
  width: 86px;
  height: 86px;
  left: 50%;
  top: -16%;
  transform: translate(-50%);
  circle {
    stroke: #afafaf;
    stroke-width: 2;
    position: relative;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export const HashLink = styled.a`
  border-radius: 8px;
  background: #27262b;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  color: #edeff5;
  text-align: center;
  text-shadow: 0px 1px 1px rgba(18, 22, 32, 0.4);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
  width: 100%;
  display: block;
  padding: 16px 0;
  margin-top: 16px;
`;
